<!--  -->
<template>
  <div>
    <van-nav-bar
      :title="$t('ShopSet.payEdit')"
      left-arrow
      fixed
      z-index="9"
      @click-left="$router.push('/ShopSet/' + sessionStorage.actShopId)"
    >
      <van-icon
        v-show="activeStore != 0"
        name="./static/img/add_staff.png"
        slot="right"
        @click="$router.push('/CreatPaymethods')"
        style="font-size: 24px;"
      />
    </van-nav-bar>
    <div class="contentWrapper">
      <van-cell-group>
        <div v-if="$i18n.locale == 'zh'">
          <van-cell
            v-for="(item, index) in payments"
            :key="index"
            :title="item.payment_method ? item.payment_method.name_cn : ''"
            is-link
            @click="$router.push('/EditPay/' + item.id)"
          />
        </div>
        <div v-if="$i18n.locale == 'hk'">
          <van-cell
            v-for="(item, index) in payments"
            :key="index"
            :title="item.payment_method ? item.payment_method.name_cn : ''"
            is-link
            @click="$router.push('/EditPay/' + item.id)"
          />
        </div>
        <div v-if="$i18n.locale == 'en'">
          <van-cell
            v-for="(item, index) in payments"
            :key="index"
            :title="item.payment_method ? item.payment_method.name_en : ''"
            is-link
            @click="$router.push('/EditPay/' + item.id)"
          />
        </div>
        <!-- <van-cell v-for="(item,index) in methods" :key="index" :title="item.name" is-link 
				@click="$router.push('/EditPay/'+item.id)"/> -->
      </van-cell-group>
    </div>
    <div class="text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      payments: [],
      activeStore: "",
      text: "",
      // methods: [],
      methodsList: []
    };
  },
  created() {
    // this.getPayments()
    this.activeStore = sessionStorage.getItem("activeStore");
    console.log(this.activeStore);
    if (this.activeStore == 0) {
      this.text = this.$t("EditBook.text");
    }
  },
  mounted() {
    this.getpaymentmethod();
    this.getPayments();
  },
  methods: {
    // 支付类型选择
    getpaymentmethod() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/paymentmethod/outside/index"
      })
        .then(res => {
          if (res.data.status == 200) {
            this.methodsList = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("StaffList.message")
          });
        });
    },
    getPayments() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build + "/api/store/" + sessionStorage.actShopId + "/payments"
      })
        .then(res => {
          if (res.data.status == 200) {
            console.log(res);
            this.payments = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("StaffList.message")
          });
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
.contentWrapper {
  padding-top: 5px;
}
.text {
  margin-top: 20px;
  font-size: 18px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/Pay/payList.vue